export default __webpack_public_path__ + "static/media/_dkg_gyn_rgb.9d1eb721.svg";